
import { REGIONS } from '@/modules/region/domain/region.js';
import { LANDING_PAGE_IDS, QUIZ_VARIANTS } from '@/modules/tour/domain/tour';

export default {
  components: {
    LandingPagesLoseWeight: () => import('@/components/landing-pages/lose-weight/lose-weight'),
  },
  asyncData({ store }) {
    store.dispatch('quiz/setQuizVariantAction', QUIZ_VARIANTS.NUTRITION_FASTING);
    store.dispatch('quiz/setLandingPageIdAction', LANDING_PAGE_IDS.NUTRITION_FASTING);
  },
  computed: {
    shouldShowLandingPage() {
      return this.$countryCode === REGIONS.us && this.getLanguage === 'en';
    },
  },
  mounted() {
    if (!this.shouldShowLandingPage) window.location.href = this.$getUrl('home');
    else this.landingPageGtmHandler();
  },
};
